export default "__VITE_ASSET__CriWwKRu__"